import React, { useState, useEffect } from 'react'
import axios from 'axios';

const ShippingOne = () => {
    const [shippingItems, setShippingItems] = useState([]);
    const [loading, setLoading] = useState(true);

 useEffect(() => {
    // Fetch shipping data from Django backend
    const fetchShippingData = async () => {
        try {
            setLoading(true);
            
            // ✅ CORRECT: axios returns response.data, not response.json()
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/shipping/`);
            
            console.log('API Response:', response.data); // Debug: Check the data structure
            
            // Django REST Framework ListAPIView returns an array directly
            setShippingItems(response.data);
            setLoading(false);
            
        } catch (error) {
            console.error('Error fetching shipping data:', error);
            setLoading(false);
        }
    };

    fetchShippingData();
}, []);


    if (loading) {
        return <div className="container container-lg">Loading...</div>;
    }

    return (
        <div className="container container-lg">
            <div className="row gy-4">
                {shippingItems && shippingItems.length > 0 ? (
                    shippingItems.map((item) => (
                        <div className="col-xxl-3 col-sm-6" key={item.id}>
                            <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                                <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                                    <i className={item.icon} />
                                </span>
                                <div className="">
                                    <h6 className="mb-0">{item.title}</h6>
                                    <span className="text-sm text-heading">
                                        {item.subtitle}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div>No shipping items available</div>
                )}
            </div>
            <br /><br />
        </div>
    )
}

export default ShippingOne